(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@makolab/library-react/dist/themeDaciaOne"] = factory();
	else
		root["@makolab/library-react/dist/themeDaciaOne"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/project_fcn_library-react/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 369);
/******/ })
/************************************************************************/
/******/ ({

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@material-ui/core/styles");

/***/ }),

/***/ 23:
/***/ (function(module, exports) {

module.exports = require("process/browser.js");

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "themeConfig", function() { return themeConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme_default__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__theme_default___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__theme_default__);
var PUBLIC_URL=process.env.PUBLIC_URL||'';// https://material-ui.com/customization/themes/
// https://cimdalli.github.io/mui-theme-generator/
var colors={white:'#fff',daciaLightBlue:'#129ade',daciaBlue:'#0089cd',daciaDarkBlue:'#10314c',daciaLightOrange:'#ff8c53',daciaOrange:'#ff671b',black:'#000'};var themeConfig=Object.assign({},__WEBPACK_IMPORTED_MODULE_1__theme_default__["baseThemeConfig"],{mlbCustomVariables:{// put your custom project theme variables here
svgIconUrl:PUBLIC_URL+'/static/svg/dacia-one-icons.svg',url:function url(path){return'url('+PUBLIC_URL+path+')';}},themeName:'Dacia One',props:{MuiButtonBase:{disableTouchRipple:true,disableRipple:true}},breakpoints:{values:{xs:340,sm:670,md:1024,lg:1280,xl:1500}},overrides:{},palette:{background:{overlay:'rgba(0,0,0,.75)'},common:{border:'#f0f3f5',borderSeparator:'#f2f2f2',dark:'#10314c',link:'#526275',separator:'#FFF',legal:'rgb(255, 255, 255)',legalBorder:'transparent',veryLightGray:'#F9F9FB',dropdownItemLink:colors.daciaDarkBlue,lightGray:'#F6F6F6',gray:'#EEEEEE',darkGray:'#979797',linkWhite:colors.white,linkBlack:colors.black,darkPreF:'#000'},primary:{light:colors.daciaLightBlue,main:colors.daciaBlue,dark:colors.daciaDarkBlue},secondary:{light:colors.daciaLightOrange,main:colors.daciaOrange,contrastText:colors.white}},typography:{useNextVariants:true,fontFamily:['readBeta2','sans-serif'].join(', '),body1:{fontSize:'14px',lineHeight:1.45},body2:{fontSize:'16px',lineHeight:1.45},button:{fontSize:'12px',lineHeight:1.15}}});var theme=Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__["createMuiTheme"])(themeConfig);/* harmony default export */ __webpack_exports__["default"] = (theme);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(23)))

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

module.exports = require("@makolab/library-react/dist/themeDefault");

/***/ })

/******/ });
});
//# sourceMappingURL=themeDaciaOne.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@makolab/library-react/dist/themeDaciaOne.js
// module id = 642
// module chunks = 0